import { cn } from '@lib/utils';

type MenuTheme = 'default' | 'disabled';

interface MenuProps {
  menus: string[];
  className?: string;
  theme?: MenuTheme;
  /** lg: 제품 하위 페이지 Hero 시안 값. 모바일 시안이 없어 데스크톱에서만 적용된다 */
  size?: 'default' | 'lg';
}

const DOT_COLOR: Record<MenuTheme, string> = {
  default: 'bg-[#676779]',
  disabled: 'bg-3b-text-disabled',
};

const LABEL_COLOR: Record<MenuTheme, string> = {
  default: 'text-3b-text-secondary',
  disabled: 'text-3b-text-disabled',
};

function menu({
  menus,
  className,
  theme = 'default',
  size = 'default',
}: MenuProps) {
  const baseClassName = 'mt-[35px] flex items-center md:mt-[70px]';
  const isLarge = size === 'lg';

  return (
    <div className={cn(baseClassName, className)}>
      <div
        className={cn(
          DOT_COLOR[theme],
          'h-[12px] w-[12px] rounded-[12px]',
          isLarge && 'md:h-[10px] md:w-[10px]',
        )}
      />
      {menus.map((menu, idx) => {
        const hasDivider = idx !== 0;

        const className = cn(
          LABEL_COLOR[theme],
          'px-[10px] text-xl font-semibold leading-7 tracking-[-0.336px]',
          hasDivider && 'border-0 border-l-2 border-solid border-[#BEC2CC]',
          isLarge &&
            'md:px-[12px] md:text-[24px] md:leading-8 md:tracking-[-0.464px]',
        );

        return (
          <div key={menu} className={className}>
            {menu}
          </div>
        );
      })}
    </div>
  );
}

export default menu;
